import React from 'react';
import type { ProductTabBlockListModel } from 'autogen/swagger/all';
import TabBlock from '../../shared/TabBlock';

export default function BlockList({ ...props }: Omit<ProductTabBlockListModel, '$type'>): JSX.Element {
    const { blocks } = props;

    return (
        <div>
            {blocks?.map((block, index) => {
                const { content } = block;
                if (!content) return null;

                return (
                    // eslint-disable-next-line react/no-array-index-key
                    <TabBlock key={index} {...block} />
                );
            })}
        </div>
    );
}
